import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";
import Home from "./pages/Home";
import Pass_About from "./pages/Pass_About";
import UserProfile from "./component/UserProfile";
import ApplyFreshPassport from "./pages/ApplyFreshPassport";
import ApplyReissuePassport from "./pages/ApplyReissuePassport";
import EnquiryAndDocument from "./pages/EnquiryAndDocument";
import Appointment_Receipt from "./pages/Appointment_Receipt";
import NameChanging from "./pages/NameChanging";
import PreviewPassport from "./component/PreviewPassport";
import Login from "./pages/Login";
import EmailForm from "./component/EmailForm";
import RegistrationForm from "./pages/RegistrationForm";
import Payments from "./pages/Payments";
import ThankYouPage from "./pages/ThankYouPage";
import NoPage from "./pages/NoPage";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import styled from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./PrivateRoute";
import MergedPassportForm from "./pages/MergedPassportForm";
const App = () => {
  // Add inside your component (before `return`)
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };
  return (
    <>
      <AuthProvider>
        <Router>
          <Navbar />
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Home" element={<Home />} />
            <Route
              path="/MergedPassportForm"
              element={<MergedPassportForm />}
            />

            <Route path="/RegistrationForm" element={<RegistrationForm />} />
            <Route path="/Login" element={<Login />} />
            <Route element={<PrivateRoute />}>
              <Route path="/UserProfile" element={<UserProfile />} />
              {/* Add other protected routes here */}
            </Route>

            <Route path="/About" element={<Pass_About />} />
            <Route path="/EmailForm" element={<EmailForm />} />
            <Route
              path="/ApplyFreshPassport"
              element={<ApplyFreshPassport />}
            />
            <Route
              path="/ApplyReissuePassport"
              element={<ApplyReissuePassport />}
            />
            <Route path="/PreviewPassport" element={<PreviewPassport />} />
            <Route
              path="/EnquiryAndDocument"
              element={<EnquiryAndDocument />}
            />
            <Route
              path="/Appointment_Receipt"
              element={<Appointment_Receipt />}
            />
            <Route path="/NameChanging" element={<NameChanging />} />
            <Route path="/Payments" element={<Payments />} />
            <Route path="/ThankYouPage" element={<ThankYouPage />} />

            <Route path="*" element={<NoPage />} />
          </Routes>
          <Footer />
        </Router>
      </AuthProvider>
      <ScrollButtonTop onClick={scrollToTop}>
        <FaArrowUp />
      </ScrollButtonTop>
      <ScrollButtonBottom onClick={scrollToBottom}>
        <FaArrowDown />
      </ScrollButtonBottom>
    </>
  );
};

export default App;
const ScrollButtonTop = styled.button`
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: #222;
  /* background: #194bfd;
  background: linear-gradient(
    90deg,
    rgba(25, 75, 253, 1) 0%,
    rgba(173, 19, 251, 1) 100%
  ); */
  color: #fff;
  border: none;
  border-radius: 10%;
  padding: 6px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  z-index: 1000;
  transition: background 0.3s;

  &:hover {
    background: #194bfd;
    background: linear-gradient(
      90deg,
      rgba(25, 75, 253, 1) 0%,
      rgba(173, 19, 251, 1) 100%
    );
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }

  svg {
    font-size: 18px;
  }
`;

const ScrollButtonBottom = styled(ScrollButtonTop)`
  bottom: 30px;

  &:hover {
    background-color: #5a189a;
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }
`;
